module.exports = __webpack_public_path__ + "static/img/logo.02e843c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 285
// module chunks = 1